import { getPointer } from "libs/schema";
import { withActionContext, write } from "./write";
import { toast } from "~/environment/toast-service";
import * as actions from "libs/actions";

/* -------------------------------------------------------------------------------------------------
 * toggleMessageReaction
 * -------------------------------------------------------------------------------------------------
 */

export const toggleMessageReaction = withActionContext(
  async (
    context,
    environment,
    props: {
      messageId: string;
      reactionId: string;
    },
  ) => {
    const pointer = getPointer("message_reactions", props.messageId);
    const [messageReactions] = await context.environment.loader.getRecord(pointer);
    const originalUserReactions = messageReactions?.reactions?.[context.currentUserId] || [];

    return {
      forward: async () => {
        let newUserReactions = originalUserReactions.slice();

        if (newUserReactions.includes(props.reactionId)) {
          newUserReactions = newUserReactions.filter((r) => r !== props.reactionId);
        } else {
          newUserReactions.push(props.reactionId);
        }

        const action = await actions.message.setMessageReactions.action(
          {
            messageId: props.messageId,
            userReactionIds: newUserReactions,
          },
          context,
        );

        await write(environment, { action });
      },
      backward: async () => {
        const action = await actions.message.setMessageReactions.action(
          { messageId: props.messageId, userReactionIds: originalUserReactions },
          context,
        );

        await write(environment, {
          action,
          onOptimisticWrite: () => {
            toast("vanilla", { subject: "Undoing message reaction." });
          },
        });
      },
    };
  },
);

/* -------------------------------------------------------------------------------------------------
 * setMessageReactions
 * -------------------------------------------------------------------------------------------------
 */

export const setMessageReactions = withActionContext(
  async (
    context,
    environment,
    props: {
      messageId: string;
      reactions: string[];
    },
  ) => {
    const pointer = getPointer("message_reactions", props.messageId);
    const [messageReactions] = await context.environment.loader.getRecord(pointer);
    const originalUserReactions = messageReactions?.reactions?.[context.currentUserId] || [];

    return {
      forward: async () => {
        const action = await actions.message.setMessageReactions.action(
          {
            messageId: props.messageId,
            userReactionIds: props.reactions,
          },
          context,
        );

        await write(environment, { action });
      },
      backward: async () => {
        const action = await actions.message.setMessageReactions.action(
          {
            messageId: props.messageId,
            userReactionIds: originalUserReactions,
          },
          context,
        );

        await write(environment, {
          action,
          onOptimisticWrite: () => {
            toast("vanilla", { subject: "Reaction undone" });
          },
        });
      },
    };
  },
);

/* -------------------------------------------------------------------------------------------------
 *  unscheduleMessageToBeSent
 * -------------------------------------------------------------------------------------------------
 */

export const unscheduleMessageToBeSent = withActionContext(
  async (context, environment, props: { messageId: string }) => {
    return {
      forward: async () => {
        const action = await actions.message.unscheduleMessageToBeSent.action(props, context);

        await write(environment, {
          action,
          onOptimisticWrite: () => {
            toast("vanilla", {
              subject: "Unsending message...",
            });
          },
        });

        toast("vanilla", {
          subject: "Unsending message...Done!",
        });
      },
    };
  },
);

/* -----------------------------------------------------------------------------------------------*/
